export default __webpack_public_path__ + "static/media/gasActiveIcon.b728a4f1.svg";